import { ReactNode } from 'react';
import { PromptType } from './RefineTab';

interface PromptCardProps {
  type: PromptType;
  name: string;
  description: string;
  icon: ReactNode;
  isSelected: boolean;
  onClick: () => void;
}

export function PromptCard({
  name,
  description,
  icon,
  isSelected,
  onClick,
}: PromptCardProps) {
  return (
    <button
      onClick={onClick}
      className={`
        relative w-full p-4 rounded-lg text-left transition-all duration-200
        ${isSelected
          ? 'bg-primary-500/20 border border-primary-500'
          : 'bg-surface-800 border border-surface-700 hover:border-surface-600'
        }
      `}
    >
      {/* Selected indicator */}
      {isSelected && (
        <div className="absolute top-3 right-3">
          <div className="w-5 h-5 rounded-full bg-primary-500 flex items-center justify-center">
            <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
      )}

      {/* Icon */}
      <div
        className={`
          w-10 h-10 rounded-lg flex items-center justify-center mb-3 transition-colors
          ${isSelected ? 'bg-primary-500/30 text-primary-300' : 'bg-surface-700 text-surface-400'}
        `}
      >
        {icon}
      </div>

      {/* Content */}
      <h4 className={`font-semibold mb-1 ${isSelected ? 'text-primary-300' : 'text-surface-200'}`}>
        {name}
      </h4>
      <p className={`text-sm ${isSelected ? 'text-surface-300' : 'text-surface-500'}`}>
        {description}
      </p>
    </button>
  );
}
